import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Racing from '@/views/Racing.vue';
import Breeding from '@/views/Breeding.vue';
import Hounds from '@/views/Hounds.vue';
import Hound from '@/views/Hound.vue';
import Leaderboards from '@/views/Leaderboards.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/racing',
    name: 'Racing',
    component: Racing,
    alias: '/'
  },
  {
    path: '/breeding',
    name: 'Breeding',
    component: Breeding
  },
  {
    path: '/hounds',
    name: 'Hounds',
    component: Hounds
  },
  {
    path: '/hounds/:id',
    name: 'Hound',
    component: Hound
  },
  {
    path: '/leaderboards',
    name: 'Leaderboards',
    component: Leaderboards
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
